import { env } from "../env";

const BASE_API_URL = env.REACT_APP_API_ENDPOINT + "v1/";

export const LOGIN_URL = `${BASE_API_URL}Login`;
export const LOGOUT = `${BASE_API_URL}Logout`;
export const VERIFY2FA = `${LOGIN_URL}/Verify2FA`;
export const VALIDATE_EMAIL = `${BASE_API_URL}Account/Reset`;
export const RESET_PASSWORD = `${BASE_API_URL}Account/Reset/Verify`;
export const VALIDATE_ACTIVATION_CODE = `${BASE_API_URL}Account/Activation/ValidateCode`;
export const ACTIVATE_ACCOUNT = `${BASE_API_URL}Account/Activation/Activate`;
export const UNBLOCK_USER = `${BASE_API_URL}Admin/User/Unlock`;
export const UPLOAD_LOGO = `${BASE_API_URL}Account/upload/logo`;
export const MODULES_PERMISSION_API = `${BASE_API_URL}Dashboard/Navigation`;
export const MASTER_DATA = `${BASE_API_URL}MasterData`;
export const MASTER_SETTINGS = `${BASE_API_URL}MasterData/Setting`;
export const UPDATE_SETTINGS = `${BASE_API_URL}settings`;
export const REPORT = `${BASE_API_URL}Report`;
export const REPORT_EXPORT = `${BASE_API_URL}Report/export`;
export const REPORT_OPTIONS = `${BASE_API_URL}Report/Options`;
export const ADMIN = `${BASE_API_URL}Admin/`;
export const ADMIN_EXPORT = `${ADMIN}export`;
export const DISTRIBUTOR = `${BASE_API_URL}distributors`;
export const ADMIN_USER = `${ADMIN}User`;
export const ADMIN_USERS = `${ADMIN}Users`;
export const ADMIN_CHANGE_STATUS = `${ADMIN}changeStatus`;
export const ADD_DISTRIBUTOR = `${BASE_API_URL}distributor`;
export const DISTRIBUTOR_EXPORT = `${ADD_DISTRIBUTOR}/export`;
export const INTERNAL_USERS = `${BASE_API_URL}internalusers`;
export const ADD_EDIT_INTERNAL_USERS = `${BASE_API_URL}internaluser`;
export const INTERNAL_USERS_EXPORT = `${ADD_EDIT_INTERNAL_USERS}/export`;
export const INTERNAL_USER_CHANGE_STATUS = `${BASE_API_URL}internaluser/ChangeStatus`;
export const ENTERPRISE_GROUP_USERS = `${BASE_API_URL}enterprises`;
export const ENTERPRISE_GROUP_USER = `${BASE_API_URL}enterprise`;
export const ENTERPRISE_GROUP_USER_RENEW = `${BASE_API_URL}enterprise/asociation/renew`;
export const ENTERPRISE_GROUP_EXPORT = `${ENTERPRISE_GROUP_USER}/export`;

export const GET_ASSOCIATE_DISTRIBITORS = `${ENTERPRISE_GROUP_USER}/distributors`;
export const GET_ASSOCIATE_DISTRIBITORS_FILTER_LIST = `${BASE_API_URL}subscriber/distributors`;
export const SUBSCRIPTION_TYPE = `${ENTERPRISE_GROUP_USER}/distributorSubscriptions`;
export const GET_SUBSCRIPTION_TYPE = `${ENTERPRISE_GROUP_USER}/distributorSubscription/`;
export const SEND_ASSOCIATE_DIST_APPROVAL = `${ENTERPRISE_GROUP_USER}/associate/distributer`;
export const BUY_SUBSCRIPTION_ENTERPRISE = `${ENTERPRISE_GROUP_USER}/associate/new`;

export const DISTRIBUTOR_INTERNAL_USER_BULK_UPLOAD = `${BASE_API_URL}internaluser/bulkupload`;
export const SUBSCRIBERS = `${BASE_API_URL}subscribers`;
export const SUBSCRIBER = `${BASE_API_URL}subscriber`;
export const ENTERPRISE = `${BASE_API_URL}enterprise/enterprises`;
export const DISTRIBUTORS = `${BASE_API_URL}distributor/distributors`;
export const SIGNUP = `${BASE_API_URL}Account/User/SignUp`;
export const SUBSCRIBER_EXPORT = `${SUBSCRIBER}/export`;
export const SUBSCRIBER_CONTENT_EXPORT = `${BASE_API_URL}subscriber/content/export`;
export const SUBSCRIBER_CONTENT_DISTBRANDNAME = `${BASE_API_URL}subscriber/subscriberId/content/distributors`;
export const GET_ED_USERS = `${BASE_API_URL}Admin/GetEDUser`;
export const MIGRATION_CHANGE_STATUS = `${BASE_API_URL}subscriber/changeMigrationStatus`;
export const CURRENT_USER = `${BASE_API_URL}auth`;
export const CONTENT = `${BASE_API_URL}content`;
export const CONTENT_EXPORT = `${CONTENT}/export`;
export const CONTENT_FAVORITE = `${CONTENT}/favorite`;
export const CONTENT_STATUS = `${CONTENT}/changestatus`;

export const CATALOG = `${BASE_API_URL}catalog`;
export const CATALOG_EXPORT = `${CATALOG}/export`;
export const CATALOG_FAVORITE = `${CATALOG}/Favorite`;
export const CATALOG_STATUS = `${CATALOG}/ChangeStatus`;
export const CATALOG_CONTENT = `${CATALOG}/content`;
export const CATALOG_ASSOCIATED_CONTENT = `${CATALOG}/associated/content`;
export const CATALOG_ASSOCIATED_CONTENT_EXPORT = `${CATALOG}/associated/content/export`;

export const BUNDLE = `${BASE_API_URL}bundle`;
export const BUNDLE_EXPORT = `${BUNDLE}/export`;
export const BUNDLE_FAVORITE = `${BUNDLE}/Favorite`;
export const BUNDLE_STATUS = `${BUNDLE}/ChangeStatus`;
export const BUNDLE_ASSOCIATED_CONTENT = `${BUNDLE}/associated/content`;
export const BUNDLE_ASSOCIATED_CONTENT_EXPORT = `${BUNDLE}/associated/content/export`;

export const AD_MANAGEMENT = `${BASE_API_URL}admanagement`;
export const AD_MANAGEMENT_STATUS = `${AD_MANAGEMENT}/changestatus`;
export const ADD_AD = `${BASE_API_URL}Ad`;
export const UPDATE_AD = `${BASE_API_URL}Ad`;
export const UPGRADE_AD = (adId) => `${BASE_API_URL}Ad/${adId}/upgrade`;
export const GET_AD = (adId) => `${BASE_API_URL}Ad/${adId}`;
export const AD_CHANGE_STATUS = `${BASE_API_URL}Ad/changestatus`;
export const AD_COPY = (adId) => `${BASE_API_URL}Ad/${adId}/copy`;
export const AD_DELETE = (adId) => `${BASE_API_URL}Ad/${adId}`;
export const AD_LIST = `${BASE_API_URL}Ad/list`;
export const AD_FORMULA = `${BASE_API_URL}Ad/formula`;
export const AD_FORMULA_CHANGELOG = `${BASE_API_URL}Ad/formula/changelog`;
export const AD_COST_CALCULATE = `${BASE_API_URL}Ad/cost/calculate`;
export const AD_AVAILABILITY = `${BASE_API_URL}Ad/availability`;
export const AD_UNAVAILABLE_DATES = `${BASE_API_URL}Ad/availability/unavailable-dates`;
export const AD_EXPORT = `${BASE_API_URL}Ad/export`;
export const AD_REPORT_EXPORT = `${BASE_API_URL}ad/analytics/report/export`;

export const SUBSCRIBER_BULK_UPLOAD = `${BASE_API_URL}subscriber/bulkupload`;

export const VENDOR = `${BASE_API_URL}vendor`;
export const VENDOR_LIST = `${VENDOR}/list`;
export const VENDOR_EXPORT = `${VENDOR}/export`;
export const VENDOR_FAVOURITE = `${VENDOR}/Favorite`;
export const VENDOR_STATUS = `${VENDOR}/ChangeStatus`;
export const VENDOR_DROPDOWN = `${VENDOR}/vendors/dropdown`;

export const VENDOR_CONTACT = `${BASE_API_URL}vendor/contact`;
export const VENDOR_CONTACT_LIST = `${VENDOR}/contact/list`;
export const VENDORCONTACT_EXPORT = `${VENDOR}/contact/export`;
export const VENDORCONTACT_FAVOURITE = `${VENDOR}/Favorite`;
export const VENDORCONTACT_STATUS = `${VENDOR}/contact/ChangeStatus`;

export const VENDOR_INTEGRATIONSOLUTION = `${BASE_API_URL}integrationSolution`;
export const VENDOR_INTEGRATIONSOLUTION_LIST = `${VENDOR_INTEGRATIONSOLUTION}/list`;
export const VENDOR_INTEGRATIONSOLUTION_EXPORT = `${VENDOR_INTEGRATIONSOLUTION}/export`;
export const VENDOR_INTEGRATIONSOLUTION_STATUS = `${VENDOR_INTEGRATIONSOLUTION}/ChangeStatus`;
export const VENDOR_INTEGRATIONSOLUTION_DROPDOWN = `${VENDOR_INTEGRATIONSOLUTION}/vendor/{vendorId}/solutions`;
export const VENDOR_INTEGRATIONSOLUTION_SUBSCRIBERS = `${VENDOR_INTEGRATIONSOLUTION}/subscribers`;

export const VENDOR_INTEGRATIONSERVICE = `${BASE_API_URL}integrationService`;
export const VENDOR_INTEGRATIONSERVICE_LIST = `${VENDOR_INTEGRATIONSERVICE}/list`;
export const VENDOR_INTEGRATIONSERVICE_EXPORT = `${VENDOR_INTEGRATIONSERVICE}/export`;
export const VENDOR_INTEGRATIONSERVICE_STATUS = `${VENDOR_INTEGRATIONSERVICE}/ChangeStatus`;
export const VENDOR_INTEGRATIONSERVICEREQUEST_UPLOADFILE = `${VENDOR_INTEGRATIONSERVICE}/uploadfile`;

export const ADDIN_LIST = `${BASE_API_URL}AddIn/List`;
export const ADDIN = `${BASE_API_URL}AddIn`;

// Returns the addins endpoint for a given enterpriseId
export const ENTERPRISE_ADDINS_URL = (enterpriseId) =>
  `${BASE_API_URL}enterprise/${enterpriseId}/addins`;
export const ENTERPRISE_ADDINS_CART_DETAILS = (enterpriseId, addInsId) =>
  `${BASE_API_URL}enterprise/${enterpriseId}/addins/${addInsId}`;
export const ADDIN_EXPORT = `${ADDIN}/export`;
export const ADDIN_STATUS = `${ADDIN}/changestatus`;
export const ADDIN_PUBLISH = `${ADDIN}/favorite`;
export const ADDIN_VENDOR_LIST = `${VENDOR}/list/dropdown`;
export const ADDIN_INTEGRATION_SOLUTION_LIST = `${VENDOR_INTEGRATIONSOLUTION}/list/dropdown`;
export const ROLE_LIST = `${BASE_API_URL}role`;
export const ADDIN_CONFIGURATION = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addin/${addInId}/manage`;
export const ADDIN_CONFIGURATIONADD = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addin/${addInId}/configurations`;
export const ADDIN_CONFIGURATIONEDIT = (
  enterpriseGroupId,
  addInId,
  configurationId,
) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addin/${addInId}/configurations/${configurationId}`;
export const ADDIN_CONFIGURATIONDELETE = (
  enterpriseGroupId,
  addInId,
  configurationId,
) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addin/${addInId}/configurations/${configurationId}`;
export const ADDIN_CONFIG_ALL_SUBS = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addon/${addInId}/subscribers/search`;
export const ADDIN_CONFIG_ALL_SUBSUPDATE = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addon/${addInId}/subscribers`;

export const ALL_ROLE_LIST = `${BASE_API_URL}AllRole`;

export const FEATURE_LIST = `${BASE_API_URL}role/feature`;

export const ADD_ROLE = `${BASE_API_URL}role`;

export const ROLE_DETAILS = `${BASE_API_URL}role/id/`;

export const UPDATE_ROLE = `${BASE_API_URL}role`;

export const MANAGE_SUBSCRIBER_LIST = `${BASE_API_URL}content/subscribers`;

export const MANAGE_SUBSCRIBER_LIST_CHANGE_STATUS = `${BASE_API_URL}content/subscriber/ChangeStatus`;

export const SUBSCRIBER_LIST_ID = `${BASE_API_URL}subscribers/list`;
export const SUBSCRIBER_ADD_ON = `${BASE_API_URL}useraddon`;
export const ENTERPRISE_SUBSCRIPTION = `${BASE_API_URL}subscriber/Subscription`;
export const SUBSCRIBER_RENEWAL_HISTORY = `${BASE_API_URL}subscriber/GetSubscriptionHistory`;
export const SUBSCRIBER_ACCESSDATA = `${BASE_API_URL}subscriber/Contents`;

export const ASSOCIATE_SUBSCRIBER = `${BASE_API_URL}content/subscriber`;

export const EXPORT_ASSOCIATE_SUBSCRIBER = `${BASE_API_URL}content/subscriber/export`;

export const EXPORT_ROLE = `${BASE_API_URL}role/export`;

export const PARENT_DISTRIBUTOR = `${BASE_API_URL}distributor/distributors`;

export const APPROVAL_LIST = `${BASE_API_URL}approval`;
export const UPDATE_APPROVAL = `${BASE_API_URL}approval/action`;
export const UPDATE_SIGNUP = `${BASE_API_URL}approval/signup/action`;

export const ENT_DIST_SUBSCRIPTION = `${BASE_API_URL}enterprise`;
export const PARENT_ENTERPRISE = `${BASE_API_URL}enterprise/enterprises`;
export const DISTRIBUTOR_SUBSCROPTIONTYPES = `${ENT_DIST_SUBSCRIPTION}/distributorSubscription`;
export const ENTERPRISE_ADD_INS = `${BASE_API_URL}user-integration-api`;
export const ENTERPRISE_ADD_INS_DATAPOST = `${BASE_API_URL}user-integration-api`;
export const BULK_UPLOAD_CONTENT_SUBSCRIBERS = `${CONTENT}/subscriber/BulkUpload`;
export const MASS_UPLOAD_CONTENT = `${CONTENT}/BulkUpload`;
export const MASS_UPLOAD_CONTENT_DOWNLOAD_PROCESSED_REQUEST = `${CONTENT}/BulkUpload/DownloadProcessedRequest`;

export const CATALOG_LIST_CONTENT_CHANGE_STATUS = `${BASE_API_URL}catalog/associatecontent/ChangeStatus`;

export const UPLOAD_DOCUMENT_URL = `${BASE_API_URL}document`;
export const ERROR_DOCUMENT_URL = `${BASE_API_URL}document/error`;

export const SHARE_VALIDATE = `${BASE_API_URL}share/validate`;
export const SHARE_VALIDATE_PASSWORD = `${SHARE_VALIDATE}/password`;
export const SHARE_ACTION = `${BASE_API_URL}Share/Action`;
export const REUSABLE_LINK_FORM = `${BASE_API_URL}public/reusablelink`;
export const REUSABLE_LINK_ACTION = `${BASE_API_URL}public/reusablelink`;
export const SHARE_Download_XFDL_TO_PDF = `${BASE_API_URL}Share/Download/XfdlToPdf`;
export const STOP_SUBSCRIPTION = `${BASE_API_URL}enterprise/association/stop`;
export const RENEWAL_HISTORY = `${BASE_API_URL}enterprise/association/history`;
export const SUBCRIPTION_DETAILS = `${BASE_API_URL}enterprise/distributor/Subscription/Association`;
export const APPROVAL_ENTERPRISE_SUBSCRIBERS = `${BASE_API_URL}approval/enterprise/Subscription/Association`;
export const ACTION_STATUS = `${BASE_API_URL}approval/subscriber/Subscription/action`;
export const ASSOCIATE_CONTENT = `${BASE_API_URL}approval/enterprise/content/subscription/action`;

export const SSO_WEB_EXCHANGE = `${BASE_API_URL}sso/web/exchange`;
export const SSO_CONTENT_LIST = `${BASE_API_URL}Mobile/content/available`;
export const SSO_FILTERS = `${BASE_API_URL}Mobile/content/filters`;
export const CONTENT_PREVIEW_FILE = `${BASE_API_URL}Mobile/content/file/{contentId}`;
export const SUBSCRIBER_SUBSCRIPTIONS = `${BASE_API_URL}Mobile/usersubscription/subscriptions`;
export const GET_CART_DETAILS = `${BASE_API_URL}mobile/cart`;
export const ADD_TO_CART = `${BASE_API_URL}mobile/cart/items`;
export const REMOVE_FROM_CART = `${BASE_API_URL}mobile/cart/items/by-item/{contentId}`;
export const CHECKOUT_CART = `${BASE_API_URL}mobile/cart/checkout`;
export const MY_CONTENT_EXISTS_SUSBCRIPTION = `${BASE_API_URL}Mobile/content`;
export const STOP_SUBSCRIBER_SUBSCRIPTION = `${BASE_API_URL}Mobile/subscriber/subscription/stop`;
export const PAYMENT_STATUS = `${BASE_API_URL}mobile/cart/payment/status`;

//mobile to browser SSO Add Ins flow API end Point
export const SSO_AVAILABLE_ADDINS_SUBSCRIPTION = `${BASE_API_URL}Mobile/addin/available`;
export const SSO_MY_ADDINS_SUBSCRIPTION_LIST = `${BASE_API_URL}Mobile/addin/my`;
export const SSO_MY_ADDINS_SUBSCRIPTION_DETAILS = (addinsId) =>
  `${BASE_API_URL}Mobile/addin/${addinsId}`;
export const SSO_SUBSCRIBER_MANAGE_CONFIGURATION = (addinsId) =>
  `${BASE_API_URL}Mobile/subscriber/addin/${addinsId}/manage`;
export const SSO_SUBSCRIBER_ADD_CONFIGURATION = (addinsId) =>
  `${BASE_API_URL}Mobile/subscriber/addin/${addinsId}/configurations`;
export const SSO_SUBSCRIBER_edit_CONFIGURATION = (addinsId, configurationId) =>
  `${BASE_API_URL}Mobile/subscriber/addin/${addinsId}/configurations/${configurationId}`;
export const SSO_SUBSCRIBER_DELETE_CONFIGURATION = (
  addinsId,
  configurationId,
) =>
  `${BASE_API_URL}Mobile/subscriber/addin/${addinsId}/configurations/${configurationId}`;
export const SSO_SUBSCRIBER_SUBSCRIPTION_MANAGEMENT = (addinsId) =>
  `${BASE_API_URL}Mobile/addin/${addinsId}/subscription`;
export const SSO_SUBSCRIBER_STOP_SUBSCRIPTION = (addinsId) =>
  `${BASE_API_URL}Mobile/addin/${addinsId}/subscription/stop`;
// Cart and checkout related APIs
export const EG_GET_CART_DETAILS = (currency) =>
  `${BASE_API_URL}cart?currency=${currency}`;
export const EG_ADD_TO_CART = `${BASE_API_URL}cart/items`;
export const EG_REMOVE_FROM_CART = (itemId) =>
  `${BASE_API_URL}cart/items/by-item/${itemId}`;
export const EG_CHECKOUT_CART = `${BASE_API_URL}cart/checkout`;
export const EG_PAYMENT_STATUS = `${BASE_API_URL}cart/payment/status`;

export const ENTERPRISE_ASSOCIATION_STOP = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addins/${addInId}/subscription/stop`;
export const ENTERPRISE_ADDINS_SUBSCRIPTION_DETAILS = (
  enterpriseId,
  addInsId,
) =>
  `${BASE_API_URL}enterprise/${enterpriseId}/addins/${addInsId}/subscription`;

export const ADMIN_MANAGE_SUBSCRIBER_LIST = (integrationSolutionId) =>
  `${BASE_API_URL}admin/addon/${integrationSolutionId}/subscribers/search`;
export const ADMIN_MANAGE_SUBSCRIBER_TOGGLE_ACCESS = (integrationSolutionId) =>
  `${BASE_API_URL}admin/addon/${integrationSolutionId}/subscribers/toggle`;

export const AD_COST_DELTA = `${BASE_API_URL}Ad/cost/delta`;

export const AD_PERFORMANCE_REPORT = `${BASE_API_URL}ad/analytics/report`;

export const ENTERPRISE_ADDINS_ACCESS = (enterpriseGroupId, addInId) =>
  `${BASE_API_URL}enterprise/${enterpriseGroupId}/addins/${addInId}/access`;
